import BlockListings from './BlockListings';
export default BlockListings;
